const VUE_APP_API_TARTARUS_URL = document.querySelector("html").getAttribute("api_tartarus_url");

export default VUE_APP_API_TARTARUS_URL